var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.92 158.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbcbc;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.94,15.64v-4.32h7.33c2.11,0,3.83-1.72,3.83-3.83v-3.66c0-2.11-1.72-3.83-3.83-3.83h-34.62c-2.11,0-3.83,1.72-3.83,3.83v3.66c0,2.11,1.72,3.83,3.83,3.83h7.33v4.32C27.01,20.5,0,50.61,0,86.9c0,39.68,32.28,71.96,71.96,71.96s71.96-32.28,71.96-71.96c0-36.29-27.01-66.4-61.98-71.26Zm-9.98,133.22c-34.17,0-61.96-27.8-61.96-61.96s27.79-61.96,61.96-61.96,61.96,27.79,61.96,61.96-27.8,61.96-61.96,61.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 71.96,
    cy: 86.9,
    r: 9.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.32,
    y1: 85.82,
    x2: 98.06,
    y2: 60.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m72.32,89.27c-.88,0-1.76-.34-2.44-1.01-1.35-1.35-1.35-3.53,0-4.87l25.74-25.74c1.35-1.35,3.53-1.35,4.87,0s1.35,3.53,0,4.87l-25.74,25.74c-.67.67-1.55,1.01-2.44,1.01Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer-icon.06c5ecaa09a4a27f8e722f2ba143ad28.svg";
export { ForwardRef as ReactComponent };